var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiIconsListaUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.25C3 4.005 4.005 3 5.25 3C6.495 3 7.5 4.005 7.5 5.25C7.5 6.495 6.495 7.5 5.25 7.5C4.005 7.5 3 6.495 3 5.25ZM4.5 5.25C4.5 5.6625 4.8375 6 5.25 6C5.6625 6 6 5.6625 6 5.25C6 4.8375 5.6625 4.5 5.25 4.5C4.8375 4.5 4.5 4.8375 4.5 5.25Z",
    fill: "#003865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9C4.005 9 3 10.005 3 11.25C3 12.495 4.005 13.5 5.25 13.5C6.495 13.5 7.5 12.495 7.5 11.25C7.5 10.005 6.495 9 5.25 9ZM5.25 12C4.8375 12 4.5 11.6625 4.5 11.25C4.5 10.8375 4.8375 10.5 5.25 10.5C5.6625 10.5 6 10.8375 6 11.25C6 11.6625 5.6625 12 5.25 12Z",
    fill: "#003865"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 15V15.75C22.5 17.4075 21.1575 18.75 19.5 18.75C17.8425 18.75 16.5 17.4075 16.5 15.75V15C16.5 13.3425 17.8425 12 19.5 12C21.1575 12 22.5 13.3425 22.5 15ZM19.5 17.25C20.325 17.25 21 16.575 21 15.75V15C21 14.175 20.325 13.5 19.5 13.5C18.675 13.5 18 14.175 18 15V15.75C18 16.575 18.675 17.25 19.5 17.25Z",
    fill: "#003865"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 18.75H21C22.6575 18.75 24 20.0925 24 21.75V22.5C24 23.325 23.325 24 22.5 24H16.5C15.675 24 15 23.325 15 22.5V21.75C15 20.0925 16.3425 18.75 18 18.75H19.5ZM16.5 21.75V22.5H22.5V21.75C22.5 20.925 21.825 20.25 21 20.25H18C17.175 20.25 16.5 20.925 16.5 21.75Z",
    fill: "#003865"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3C10.005 3 9 4.005 9 5.25V7.5H18.75C19.995 7.5 21 6.495 21 5.25V3H11.25ZM19.5 5.25C19.5 5.6625 19.1625 6 18.75 6H10.5V5.25C10.5 4.8375 10.8375 4.5 11.25 4.5H19.5V5.25Z",
    fill: "#003865"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.25C3 16.005 4.005 15 5.25 15C6.495 15 7.5 16.005 7.5 17.25C7.5 18.495 6.495 19.5 5.25 19.5C4.005 19.5 3 18.495 3 17.25ZM4.5 17.25C4.5 17.6625 4.8375 18 5.25 18C5.6625 18 6 17.6625 6 17.25C6 16.8375 5.6625 16.5 5.25 16.5C4.8375 16.5 4.5 16.8375 4.5 17.25Z",
    fill: "#003865"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15H11.25C10.005 15 9 16.005 9 17.25V19.5H13.5C13.9125 19.5 14.25 19.1625 14.25 18.75C14.25 18.3375 13.9125 18 13.5 18H10.5V17.25C10.5 16.8375 10.8375 16.5 11.25 16.5H14.25C14.6625 16.5 15 16.1625 15 15.75C15 15.3375 14.6625 15 14.25 15Z",
    fill: "#003865"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C9 10.005 10.005 9 11.25 9H21V9.75C21 10.1625 20.6625 10.5 20.25 10.5H11.25C10.8375 10.5 10.5 10.8375 10.5 11.25V12H14.25C14.6625 12 15 12.3375 15 12.75C15 13.1625 14.6625 13.5 14.25 13.5H9V11.25Z",
    fill: "#003865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIconsListaUsuario);
export default __webpack_public_path__ + "static/media/bi-icons-lista-usuario.305c4cf3d637c580d344ae89db85305d.svg";
export { ForwardRef as ReactComponent };